import React from "react"
import { COLORS } from "../../../utilities/Constants"
import { useAssistances, useResumeMission } from "./AssistancesContext"

// Ligne dossier en bas de DepMissionCardV2 (GE-57, spec §11.1) :
// « 📁 <Assistance> <réf> · n ordres · ⚠ k », ou « 🚚 transport commandé »
// quand un ordre de transport attend la clôture de cette mission. Absente
// sans dossier (ou hors du dispatch : pas de provider).
const LigneDossierCarte = ({ missionId }) => {
	const ctx = useAssistances()
	const r = useResumeMission(missionId)
	if (!ctx || !r) return null
	const ouvrir = (e) => {
		e.stopPropagation()
		ctx.ouvrirDossier(r.dossier_id)
	}
	return (
		<button
			type="button"
			style={st.ligne}
			onClick={ouvrir}
			title="Ouvrir le dossier d'assistance"
		>
			<span role="img" aria-label="Dossier">
				📁
			</span>
			<span style={{ fontWeight: 700, whiteSpace: "nowrap" }}>
				{r.assistance} {r.ref_affaire}
			</span>
			<span style={{ color: COLORS.textLight }}>·</span>
			<span style={{ whiteSpace: "nowrap" }}>
				{r.nb_ordres} ordre{r.nb_ordres > 1 ? "s" : ""}
			</span>
			{r.nb_propositions > 0 ? (
				<span style={st.alerte}>⚠ {r.nb_propositions}</span>
			) : r.adresse_signalee ? (
				// Revue 5, décision 5 : mission chez le dépanneur, l'e-mail
				// indique une autre adresse (rien n'est modifié) → prévenir.
				<span
					style={st.alerte}
					title={`Prévenir le dépanneur : ${r.adresse_signalee.adresse || ""}`}
				>
					⚠ L'assistance indique une nouvelle adresse
				</span>
			) : r.transport_commande ? (
				<span style={st.info}>
					<span role="img" aria-label="">
						🚚
					</span>{" "}
					transport commandé
				</span>
			) : null}
		</button>
	)
}

const st = {
	ligne: {
		padding: "7px 10px",
		lineHeight: "18px",
		borderRadius: 8,
		border: `1px solid ${COLORS.border}`,
		backgroundColor: COLORS.bg,
		display: "flex",
		alignItems: "center",
		gap: 8,
		cursor: "pointer",
		fontSize: 12.5,
		color: COLORS.text,
		textAlign: "left",
		width: "100%",
		flexWrap: "wrap",
		rowGap: 2,
		fontFamily: "inherit",
		boxSizing: "border-box",
	},
	alerte: { marginLeft: "auto", color: COLORS.danger, fontWeight: 700 },
	info: {
		marginLeft: "auto",
		color: COLORS.warning,
		fontWeight: 600,
		fontSize: 11.5,
		whiteSpace: "nowrap",
	},
}

export default LigneDossierCarte
